import React from 'react';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import FieldLabel from '../components/FieldLabel';
import { getFieldLabel } from '../utils/formHelpers';
import { outlinedFieldProps } from '../utils/fieldStyles';

const DaySelectField = ({
    field,
    data,
    change,
    hasError,
    itineraryDaysList = [],
}) => {
    const days = itineraryDaysList || [];
    return (
        <TextField
            {...outlinedFieldProps}
            select
            label={<FieldLabel label={getFieldLabel(field)} tooltip={field.tooltip} />}
            value={data[field.key] || ''}
            onChange={(e) => change(field.key, e.target.value)}
            error={hasError}
            helperText={
                hasError
                    ? 'This field is required'
                    : (days.length === 0) ? 'No itinerary days found 0 save the Itinerary step first' : ''
            }
        >
            <MenuItem value="">Select a Day...</MenuItem>
            {days.map((d) => (
                <MenuItem key={d.id} value={d.id}>
                    {d.label}
                </MenuItem>
            ))}
        </TextField>
    );
};

export default DaySelectField;
